import {Outlet} from 'react-router-dom';
import {AuthHeader} from './AuthHeader';
import {AuthMixpanel} from './AuthMixpanel';

export const AuthLayout = () => {
  return (
    <>
      <AuthMixpanel />
      <AuthHeader />
      <Outlet />
    </>
  );
};
